import React from 'react'
import { Link } from 'react-router-dom';
import ReactTimeago from 'react-timeago';
import { useRecents } from '../../../services/history';
import { iconMap } from '../../../services/routing/routes';
import { Button } from '../inputs/button';
import { Card } from './card';
import { ReactComponent as RecentsIcon } from './../../../assets/icons/recents.svg';


import styles from './recentsCard.module.css';

export const RecentsCard = () => {

    const recents = useRecents();

    return <Card className={styles.Card}>

        <h1>Recents</h1>
        
        <div className={styles.Recents}>
        {
            recents.length === 0 ? <div className={styles.NoRecentsMsg}>
                <div className={styles.NoRecents}>
                    <div className='icon text-color'>
                        <RecentsIcon />
                    </div>
                </div>
                <h2>No recent items</h2>
            </div> : recents.reverse().map(r => {

                let Icon = iconMap[r.resource];
                
                return (<div key={r.timestamp} className={styles.Recent}>
                    <div className={'icon ' + styles.Icon}>
                        {Icon && <Icon />}
                    </div>
                    <div className={styles.Info}>
                        <h2>{r.title}</h2>
                        <h3>Viewed <ReactTimeago date={r.timestamp} /></h3>
                    </div>
                    {
                        r.url && <Link to={r.url}>
                            <Button className='primary'>View</Button>
                        </Link>
                    }
                </div>);
            })
        }
        </div>
    </Card>
}